// extracted by mini-css-extract-plugin
export default {"defaultChart":"SavingsGraph_defaultChart__0tZLL","breakEvenLabel":"SavingsGraph_breakEvenLabel__wJQSY"};